/**
 * 점검 API 서비스
 */
import { apiClient } from "../../../../core/api/client";
import { ActiveMaintenanceResponse, DEFAULT_MAINTENANCE_RESPONSE } from "../types/maintenance";

const BASE_PATH = '/api/v1/system/maintenance';

/**
 * 현재 활성화된 점검 조회
 * GET /api/v1/system/maintenance/active
 */
export const getActiveMaintenance = async (): Promise<ActiveMaintenanceResponse> => {
    try {
        const response = await apiClient.get<ActiveMaintenanceResponse>(
            `${BASE_PATH}/active`
        );
        return response.data;
    } catch {
        // API 오류 시 기본값 반환 (점검 아님으로 처리)
        return DEFAULT_MAINTENANCE_RESPONSE;
    }
};
